export class Aluno{
  nome: string
  endereco: string
  municipioUF: string
  nomeDoPai:string
  nomeDaMae: string
  naturalidade: string
  nacionalidade: string
  dataDeNascimento: string
  rg: string
  orgaoExpedidor: string
  dataExpedicao: string
  cpf: string
  telefone: string
  email: string
  observacao: string
  matricula: string
  constructor(){}
}
